import { QueryParamProvider } from '../application/ports/QueryParamProvider';

export class QueryParamAdapter implements QueryParamProvider {
  getAll(): Record<string, string | null> {
    const params = this.getParametersFromURL();
    const result: Record<string, string | null> = {};
    params.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }

  get(param: string): string | null {
    const params = this.getParametersFromURL();
    return params.get(param);
  }

  private getParametersFromURL() {
    return new URLSearchParams(window.location.search);
  }
}
